import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

const safeSelector = (rootState: RootState) => rootState.hostOrganization;

export const currentOrganizationSelector = createSelector(
  safeSelector,
  (state) => state.currentOrganization,
);

export const organizationStatusSelector = createSelector(
  safeSelector,
  (state) => state.organizationStatus,
);

export const organizationMembersSelector = createSelector(safeSelector, (state) => state.members);

export const organizationLoadingSelector = createSelector(safeSelector, (state) => state.isLoading);

export const organizationErrorSelector = createSelector(safeSelector, (state) => state.error);

export const statusLoadingSelector = createSelector(safeSelector, (state) => state.statusLoading);

export const statusErrorSelector = createSelector(safeSelector, (state) => state.statusError);

export const membersLoadingSelector = createSelector(safeSelector, (state) => state.membersLoading);

export const membersErrorSelector = createSelector(safeSelector, (state) => state.membersError);

export const createLoadingSelector = createSelector(safeSelector, (state) => state.createLoading);

export const createErrorSelector = createSelector(safeSelector, (state) => state.createError);

export const updateLoadingSelector = createSelector(safeSelector, (state) => state.updateLoading);

export const updateErrorSelector = createSelector(safeSelector, (state) => state.updateError);

export const inviteLoadingSelector = createSelector(safeSelector, (state) => state.inviteLoading);

export const inviteErrorSelector = createSelector(safeSelector, (state) => state.inviteError);

export const shouldPromptOrganizationSetupSelector = createSelector(
  safeSelector,
  (state) => state.organizationStatus?.should_prompt ?? false,
);

export const hasOrganizationSelector = createSelector(
  safeSelector,
  (state) => state.organizationStatus?.has_organization ?? false,
);
